import { render, staticRenderFns } from "./AccountMainLayout.vue?vue&type=template&id=4f1e23b2"
import script from "./AccountMainLayout.vue?vue&type=script&lang=ts"
export * from "./AccountMainLayout.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports